import client from "../lib/api/client";

const isLogin = async () => {
    const authResult = client.post('/kognr/auth').then(response => {
        return response.data;
    }).catch(error => {
        console.log(error.response);
        if (error.response.status === 401) {
            window.location.replace("/");
        }
    });

    return authResult;
};

export default isLogin;
